import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Head } from '~/components/shared/Head';
import { AdvanceSettings } from './components/AdvanceSettings';
import { SettingsNavigation } from './components/SettingsNavigation';
import ActionBar from '../teams/components/ActionBar';
import Users from '../teams/components/Users';
import Tags from '../teams/components/Tags';
import ProfileAttributes from '../teams/components/ProfileAttributes';
import { DangerZone } from './components/DangerZone';
import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_ADVANCE_SETTINGS } from '~/services';

const Settings = () => {
  const [t] = useTranslation('advance_settings');
  const { agentId } = useParams();
  const [searchValue, setSearchValue] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('');
  const [selectedSort, setSelectedSort] = useState('');
  const [isAddClicked, setIsAddClicked] = useState(false);

  // Get channels data for DangerZone
  const { data } = useQuery(GET_ADVANCE_SETTINGS, {
    variables: {
      data: {
        agent_id: agentId,
      },
    },
  });

  const channels = data?.get_advance_settings?.data?.channels || [];

  return (
    <div className="m-auto w-full max-w-[1200px] px-8 pt-12">
      <Head title={t('title')} />
      <h1 className="text-2xl font-medium">{t('title')}</h1>

      <SettingsNavigation />

      <div className="mb-24 w-full lg:mb-0">
        <Routes>
          <Route path="/" element={<Navigate to="users" replace />} />
          <Route 
            path="users/*" 
            element={
              <>
                <ActionBar
                  searchValue={searchValue}
                  onSearchChange={setSearchValue}
                  onFilterChange={setSelectedFilter}
                  onSortChange={setSelectedSort}
                  onAddClick={() => setIsAddClicked(true)}
                  titleKey="title_users"
                />
                <div className="overflow-y-scroll rounded-2xl bg-base-100 p-6">
                  <Users
                    searchValue={searchValue}
                    selectedFilter={selectedFilter}
                    selectedSort={selectedSort}
                    isAddClicked={isAddClicked}
                    setIsAddClicked={setIsAddClicked}
                  />
                </div>
              </>
            } 
          />
          <Route 
            path="tags" 
            element={
              <>
                <ActionBar
                  searchValue={searchValue}
                  onSearchChange={setSearchValue}
                  onFilterChange={setSelectedFilter}
                  onSortChange={setSelectedSort}
                  onAddClick={() => setIsAddClicked(true)}
                  titleKey="title_tags"
                />
                <div className="overflow-y-scroll rounded-2xl bg-base-100 p-6">
                  <Tags
                    searchValue={searchValue}
                    selectedFilter={selectedFilter}
                    selectedSort={selectedSort}
                    isAddClicked={isAddClicked}
                    setIsAddClicked={setIsAddClicked}
                  />
                </div>
              </>
            } 
          />
          <Route 
            path="profile" 
            element={
              <>
                <ActionBar
                  searchValue={searchValue}
                  onSearchChange={setSearchValue}
                  onFilterChange={setSelectedFilter}
                  onSortChange={setSelectedSort}
                  onAddClick={() => setIsAddClicked(true)}
                  titleKey="title_profile_settings"
                />
                <div className="overflow-y-scroll rounded-2xl bg-base-100 p-6">
                  <ProfileAttributes
                    searchValue={searchValue}
                    selectedFilter={selectedFilter}
                    selectedSort={selectedSort}
                    isAddClicked={isAddClicked}
                    setIsAddClicked={setIsAddClicked}
                  />
                </div>
              </>
            } 
          />
          <Route 
            path="danger" 
            element={
              <div className="rounded-2xl bg-base-100 p-6">
                <DangerZone agentId={agentId!} channels={channels} />
              </div>
            } 
          />
        </Routes>
      </div>
    </div>
  );
};

export default Settings;
